import * as React from "react";
export const ComingSoonContext = React.createContext(null);
export const ComingSoonProvider = ({ children }) => {
  const [t, n] = React.useState({
    visible: false,
    x: 0,
    y: 0,
  });
  const r = React.useRef(null);
  const i = React.useCallback((s, l) => {
    if (r.current) {
      clearTimeout(r.current);
    }
    n({
      visible: true,
      x: s,
      y: l,
    });
    r.current = setTimeout(() => {
      n((c) => ({
        ...c,
        visible: false,
      }));
    }, 1500);
  }, []);
  const o = React.useCallback(() => {
    if (r.current) {
      clearTimeout(r.current);
    }
    n((s) => ({
      ...s,
      visible: false,
    }));
  }, []);
  return (
    <ComingSoonContext.Provider
      value={{
        showTooltip: i,
        hideTooltip: o,
        tooltipState: t,
      }}
    >
      {children}
    </ComingSoonContext.Provider>
  );
};
/**
 * @license lucide-react v1.47.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

export const ComingSoonTooltip = ({ children }) => {
  const [t, n] = React.useState({
    x: 0,
    y: 0,
    visible: false,
  });
  React.useEffect(() => {
    const r = (i) => {
      if (i.target.closest("[data-coming]")) {
        i.preventDefault();
        n({
          x: i.clientX,
          y: i.clientY,
          visible: true,
        });
        setTimeout(
          () =>
            n((l) => ({
              ...l,
              visible: false,
            })),
          1200,
        );
      }
    };
    window.addEventListener("click", r);
    return () => window.removeEventListener("click", r);
  }, []);
  return (
    <React.Fragment>
      {children}
      {t.visible && (
        <div
          className="fixed z-[9999] pointer-events-none px-2 py-1 bg-[#006AFF] text-white text-base font-bold rounded shadow-xl animate-in fade-in zoom-in duration-200"
          style={{
            left: t.x + 12,
            top: t.y - 12,
          }}
        >
          COMING SOON
        </div>
      )}
    </React.Fragment>
  );
};
